import { CollectionTemplateTreeItem } from './CollectionTemplateTreeItem'
import { useCallback } from 'react'
import clsx, { ClassValue } from 'clsx'
import { TemplateItem } from '../template-item'

export type CollectionTemplateTreeProps = {
  item: TemplateItem
  foldersState: Record<string, boolean>
  setFoldersState: React.Dispatch<React.SetStateAction<Record<string, boolean>>>
  selectedTable: TemplateItem | null
  setSelectedTable: React.Dispatch<TemplateItem>
  rootItem?: boolean
  className?: ClassValue
}

export function CollectionTemplateTree (props: CollectionTemplateTreeProps) {
  const { item, foldersState, selectedTable, rootItem, className, setFoldersState, setSelectedTable } = props

  const handleClickItem = useCallback(() => {
    if (item.type === 'folder') {
      setFoldersState(prev => ({
        ...prev,
        [item.id]: !prev[item.id]
      }))
    } else if (item.type === 'database') {
      setSelectedTable(item)
    }
  }, [item.id, setFoldersState])

  const isFolderOpen = foldersState[item.id]
  const isSelected = selectedTable?.id === item.id

  return (
    <ul className={clsx(className, { 'ml-3': !rootItem })}>
      <li>
        <CollectionTemplateTreeItem
          item={item}
          onClickItem={handleClickItem}
          isFolderOpen={isFolderOpen}
          isSelected={isSelected}
        />

        {isFolderOpen && item.children?.map(child => (
          <CollectionTemplateTree
            key={child.id}
            item={child}
            foldersState={foldersState}
            setFoldersState={setFoldersState}
            selectedTable={selectedTable}
            setSelectedTable={setSelectedTable}
          />
        ))}
      </li>
    </ul>
  )
}
